import { useState } from "react";
import { NavLink } from "react-router-dom";
import { useLanguageContext } from "../../../Components/Languages/Langs/LanguageContext";
import useAuth from "../../../Redux/useAuth";
import {
  AuthorApp,
  AuthorAppLink,
  ButtonContantUs,
  ButtonCredit,
  ButtonLocalData,
  ButtonMainInfo,
  ButtonSecurity,
  ContainerCreditPage,
  ContainerLogos,
  ContainerSocialMedia,
  CreditContainer,
  FounderContainer,
  HeaderCreditsPage,
  InstagramLogoIcon,
  Languages,
  ThreadsLogoIcon,
  Title,
  TitlePage,
  YouTubeLogoIcon,
} from "./CreditsPageStyle.styled";
import { ButtonBackPage } from "../SecurityPage/SecurityPageStyles.styled";
import { ButtonBackPageIcon } from "../../MainInfo/Icons/Icons";
import {
  ContainerButton,
  NameUser,
  NicNameUserColor,
} from "../LanguagesPage/LanguagesPageStyles.styled";
import { ButtonLogOut } from "../../../Components/ModelWindows/Logout/LogOut.styled";
import { ModelWindow } from "../../../Components/ModelWindow/ModelWindow";
import { Logout } from "../../../Components/ModelWindows/Logout/Logout";
import YouTubeLogo from "./imgs/yt_icon_rgb.png";
import InstagramLogo from "./imgs/Instagram_Glyph_Gradient.png";
import threadsLogo from "./imgs/threads-logo-black-01.png";

export const CreditPage = () => {
  const { user } = useAuth();
  const { t } = useLanguageContext();

  const youtubeLink: string = "https://www.youtube.com/@picsworldstudio";
  const instagramLink: string = "https://www.instagram.com/picsworldstudio";
  const threadsLink: string = "https://www.threads.com/@picsworldstudio";
  const linkWebsiteStudio: string = "https://picsworldstudio.com/";

  const [openModelLogOut, setOpenModelLogOut] = useState(false);
  const [showLogOut, setShowLogOut] = useState(false);

  const openLogOut = () => {
    setShowLogOut(true);
    setTimeout(() => setOpenModelLogOut(true), 0);
  };

  const closeLogOut = () => {
    setOpenModelLogOut(false);
    setTimeout(() => setShowLogOut(false), 250);
  };
  return (
    <>
      <HeaderCreditsPage>
        <NavLink to={`/home-page/${user?.name?.toLowerCase()}}`}>
          <ButtonBackPage>
            <ButtonBackPageIcon />
          </ButtonBackPage>
        </NavLink>
        <NameUser>
          {t("privateTraslate.privateHeaderNameUser")}
          <NicNameUserColor> {user?.name || "User"}</NicNameUserColor>
        </NameUser>
        <TitlePage>{t("privateTraslate.TitleCredit")}</TitlePage>
      </HeaderCreditsPage>
      <ContainerCreditPage>
        <ContainerButton>
          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/main-info`}>
            <ButtonMainInfo>
              {t("privateTraslate.updateDataUserPageTitle")}
            </ButtonMainInfo>
          </NavLink>

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/security-page`}>
            <ButtonSecurity>
              {t("privateTraslate.securityPageTitle")}
            </ButtonSecurity>
          </NavLink>

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/languages`}>
            <Languages>{t("privateTraslate.languagesPageTitle")}</Languages>
          </NavLink>

          {/* <NavLink to={`/home-page/${user?.name?.toLowerCase()}/modes`}>
                <ButtonModes>{t("privateTraslate.ModesPage")}</ButtonModes>
            </NavLink> */}

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/local-data`}>
            <ButtonLocalData>
              {t("privateTraslate.LocalDataPage")}
            </ButtonLocalData>
          </NavLink>

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/contacts`}>
            <ButtonContantUs>
              {t("privateTraslate.contactUsPageTitle")}
            </ButtonContantUs>
          </NavLink>
          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/credits`}>
            <ButtonCredit>{t("privateTraslate.ButtonCredit")}</ButtonCredit>
          </NavLink>

          <ButtonLogOut onClick={openLogOut}>
            {t("privateTraslate.logOutButton")}
          </ButtonLogOut>
        </ContainerButton>
        <CreditContainer>
          <FounderContainer>
            <Title>{t("privateTraslate.founder")}</Title>
            <AuthorApp>
              <AuthorAppLink
                href={linkWebsiteStudio}
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                PicsWorldStudio
              </AuthorAppLink>
            </AuthorApp>
          </FounderContainer>
          <ContainerSocialMedia>
            <Title>{t("privateTraslate.media")}</Title>
            <ContainerLogos>
              <a
                href={youtubeLink}
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                <YouTubeLogoIcon src={YouTubeLogo} alt="YouTube-logo" />
              </a>
              <a
                href={instagramLink}
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                <InstagramLogoIcon src={InstagramLogo} alt="Instagram-logo" />
              </a>
              <a
                href={threadsLink}
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                <ThreadsLogoIcon src={threadsLogo} alt="threads-logo" />
              </a>
            </ContainerLogos>
          </ContainerSocialMedia>
        </CreditContainer>
      </ContainerCreditPage>

      {showLogOut && (
        <ModelWindow onClose={closeLogOut} isOpen={openModelLogOut}>
          <Logout onClose={closeLogOut} />
        </ModelWindow>
      )}
    </>
  );
};
